import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "react-bootstrap";
import SideBar from "./SideBar";
import { IoClose } from "react-icons/io5";

const MobileFilters = ({ isOpen, toggle, filters, setFilters, allFlights }) => {
    return (
        <Offcanvas
            placement="end"
            show={isOpen}
            onHide={toggle}
            className="h-screen w-[90%] md:w-[60%] lg:w-[30%] xl:w-[20%] "
            tabIndex={-1}
            id="offcanvasSiddebar"
            aria-labelledby="filters"
        >
            <OffcanvasHeader className="offcanvas-header py-2 px-3  w-full flex justify-between items-center">
                <h5 className="font-semibold">Filters</h5>
                <div className="">
                    <IoClose cursor="pointer" onClick={toggle} size={22} />
                </div>
            </OffcanvasHeader>
            <OffcanvasBody className="offcanvas-body flex-column p-2 ">
                <SideBar 
                    filters={filters} 
                    setFilters={setFilters} 
                    allFlights={allFlights}
                />
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default MobileFilters;
